import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 188 270"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F04E41",
      d: "M72.548 82.034 25.447 3.567S23.386 0 16.849 0C10.313 0 .35.149.002 5.748c-.34 5.6 47.788 80.18 47.788 80.18zM115.452 187.96l47.101 78.473s2.061 3.567 8.598 3.567c6.529 0 16.501-.149 16.847-5.748s-47.788-80.18-47.788-80.18z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F04E41",
      d: "M152.254 203.546q1.788 2.862 2.137 4.548.342 1.692-.895 2.663c-.826.648-2.187 1.082-4.065 1.302-1.885.214-4.387.327-7.513.327-2.944 0-5.238-.066-6.896-.197q-2.478-.195-3.926-.713-1.449-.516-2.206-1.236c-.505-.476-.946-1.106-1.311-1.885l-39.702-66.953-40.112 66.953c-.46.779-.964 1.433-1.519 1.95-.555.523-1.31.933-2.275 1.236-.964.304-2.275.524-3.927.648q-2.477.197-6.618.197-4.547.002-7.166-.327c-1.746-.22-2.963-.648-3.656-1.302-.687-.648-.92-1.54-.687-2.663.227-1.124.94-2.646 2.137-4.548l48.658-77.356L26.26 51.432q-1.654-2.864-2.137-4.613-.48-1.756.618-2.729 1.106-.97 3.857-1.236c1.84-.173 4.362-.262 7.582-.262 2.755 0 5.011.066 6.757.197q2.62.194 4.135.647 1.514.455 2.206 1.302.688.849 1.519 1.885l38.321 62.922 38.045-62.922c.46-.696.92-1.32 1.38-1.885s1.122-.992 1.998-1.302q1.303-.453 3.656-.648 2.343-.196 6.34-.196 4.272-.001 6.965.327 2.685.328 3.857 1.237c.782.606 1.078 1.498.895 2.663q-.273 1.757-1.928 4.613l-46.32 74.235z"
    }, null, -1)
  ])))
}
export default { render: render }